// extracted by mini-css-extract-plugin
module.exports = {"inputName":"styles_inputName__2WI19","unselectable":"styles_unselectable__1jq6M","actions":"styles_actions__KGjVJ","warning":"styles_warning__35A0D","icon":"styles_icon__k84o4"};